import { ElementType, Suspense } from 'react'
import AmeSpin from '@/components/AmeSpin/AmeSpin'
import { PAGE_LINKS, PC_PAGE_LINKS, MOBILE_PAGE_LINKS } from '@/helpers/commonConsts'
import { commonUtils } from '@/helpers/commonUtils'

const Loadable = (Component: ElementType) => (props: any) => {
  // 判断设备类型和页面路径是否匹配
  const isMobile = commonUtils.isMobile()
  const isPcRoute = Object.values(PC_PAGE_LINKS).some((link) => window.location.pathname === link)
  const isMobileRoute = Object.values(MOBILE_PAGE_LINKS).some((link) => window.location.pathname === link)
  // 移动端访问PC页面，跳转到移动端
  if (isPcRoute && isMobile && window.location.pathname !== '/pc/ai'
    && window.location.pathname !== '/pc/coupon'&& window.location.pathname !== '/pc/coupon-center')
    {
    window.location.href = window.location.origin + PAGE_LINKS.home
    return null
  }

  // PC端访问移动端页面，跳转到PC端
  if (isMobileRoute && !isMobile && window.location.pathname !=='/mobile/coupon_claim'
     && window.location.pathname !== '/mobile/coupon-center') {
    window.location.href = window.location.origin + PAGE_LINKS.pcHome
    return null
  }

  return (
    <Suspense
      fallback={
        <div
          style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <AmeSpin fullscreen={true} />
        </div>
      }
    >
      <Component {...props} />
    </Suspense>
  )
}

export default Loadable
